// ----------------------------------------------------------------------

export default function ToggleButton(theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: theme.palette.grey[500_48],
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            color: theme.palette.grey[isLight ? 600 : 0],
          },
          border: `solid 1px ${theme.palette.grey[500_32]}`,
          color: theme.palette.grey[500],
        },
      },
    },
  };
}
